let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lkM4h")).then(() => parcelRequire('ePHET'));